import { useState } from 'react';
import Button from '../../../components/base/Button';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

export default function CTASection() {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  return (
    <section className="py-20 bg-[#212026]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Let's Create Your Next Project with Precision
          </h2>
          <p className="text-xl text-[#dbcfbf] mb-8 max-w-3xl mx-auto">
            Ready to experience the difference that professional engineering and design expertise can make?
            Let's discuss your project requirements and deliver solutions that exceed your expectations.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <Button 
              onClick={() => setIsQuoteOpen(true)}
              variant="outline" 
              size="lg" 
              className="!border-[#dbcfbf] !text-[#dbcfbf] !hover:bg-[#dbcfbf] !hover:text-[#212026]"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-phone-line"></i>
              </div>
              Request a Quote
            </Button>
          </div>

          <RequestQuotePopup 
            isOpen={isQuoteOpen} 
            onClose={() => setIsQuoteOpen(false)} 
            serviceName="General Inquiry"
          />
        </div>
      </div>
    </section>
  );
}
